import {
    GET_SLACK_EVENT_RESPONSE,
    FETCH_SLACK_EVENT_RESPONSE,
    EDIT_SLACK_EVENT_RESPONSE,
    ADD_SLACK_EVENT_RESPONSE,
    DELETE_SLACK_EVENT_RESPONSE,
    CLEAR_SLACK_EVENT_RESPONSE,
    CLEAR_ALL,
    PENDING_SLACK_EVENT_RESPONSE,
    SLACK_EVENT_RESPONSE_PAGE,
  } from "../constants/actions";
  
  const initialState = {
    slack_event_responses: [],
    pending: false,
    pageNumber: 1,
    created: false,
    updated: false,
  };
  
  export default function slackEventResponse(state = initialState, action) {
    switch (action.type) {
      case PENDING_SLACK_EVENT_RESPONSE:
        return {
          ...state,
          pending: true,
        };
      case GET_SLACK_EVENT_RESPONSE:
        return {
          ...state,
          slack_event_responses: action.payload,
          pending: false,
        };
      case SLACK_EVENT_RESPONSE_PAGE:
        return {
          ...state,
          pageNumber: action.payload,
        };
      case FETCH_SLACK_EVENT_RESPONSE:
        return {
          ...state,
          [action.payload.id]: action.payload,
          pending: false,
        };
      case EDIT_SLACK_EVENT_RESPONSE:
        return {
          ...state,
          [action.payload.id]: action.payload,
          pending: false,
        };
      case ADD_SLACK_EVENT_RESPONSE:
        return {
          ...state,
          created: action.payload,
          pending: false,
        };
      case DELETE_SLACK_EVENT_RESPONSE:
        return {
          ...state,
          updated: Math.random(),
          pending: false,
        };
      case CLEAR_SLACK_EVENT_RESPONSE:
        return {
          ...state,
          ...initialState,
        };
      case CLEAR_ALL:
        return initialState;
      default:
        return state;
    }
  }